import React from "react";
import Page from "../../../../components/page/Page";
import PageContent from "../../../../components/page/PageContent";
import PageHeader from "../../../../components/page/PageHeader";
import PageTitle from "../../../../components/page/PageTitle";
import {t} from "../../../../store/localization/TranslMessasge";
import StereotypesGrid from "./StereotypesGrid";
import {StereotypesTranslationKey} from "./StereotypesTranslationKey";


export default function StereotypesPage() {

    return(
        <Page>
            <PageHeader>
                <PageTitle title={t(StereotypesTranslationKey.STEREOTYPES)} />
            </PageHeader>
            <PageContent>
                <StereotypesGrid />
            </PageContent>
        </Page>
    )
}
